export const Header = {
  fixed: (state = false) => {
    const header = document.querySelector('#header')
    
		header.setAttribute('data-fixed', state)
    state ? header.classList.add('is-fixed') : header.classList.remove('is-fixed')
  }
}